import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '../useApiClient'
import {
  getDimCatalog,
  getValueLabels,
  getLatestRevision,
  getKpiDimStackable,
} from '../endpoints/catalog'

export function useDimCatalog() {
  const client = useApiClient()
  return useQuery({
    queryKey: ['v_dim_catalog'] as const,
    queryFn: () => getDimCatalog(client),
    staleTime: Infinity,
  })
}

export function useValueLabels(factTable: string | null) {
  const client = useApiClient()
  return useQuery({
    queryKey: ['v_value_labels', factTable] as const,
    queryFn: () => getValueLabels(client, factTable!),
    enabled: factTable !== null,
    staleTime: Infinity,
  })
}

export function useLatestRevision() {
  const client = useApiClient()
  return useQuery({
    queryKey: ['v_latest_data_update_rev'] as const,
    queryFn: () => getLatestRevision(client),
    refetchInterval: 60_000,
    staleTime: 30_000,
  })
}

export function useKpiDimStackable(factTable: string | null) {
  const client = useApiClient()
  return useQuery({
    queryKey: ['v_kpi_dim_stackable', factTable] as const,
    queryFn: () => getKpiDimStackable(client, factTable!),
    enabled: factTable !== null,
    staleTime: Infinity,
  })
}
